<template>
    <div class="dialog-box">
        <!-- 合同弹框 -->
        <ContractSignDialog :visible.sync="signVisible" @confirm="handleContractConfirm"></ContractSignDialog>

        <!-- 验收操作等弹框，淘汰-备选-终止合同-返工-通过 -->
        <AcceptanceDialog
            ref="acceptDialogRef"
            :visible.sync="acceptance.visible"
            :title="acceptance.title"
            :form-options="acceptance.formOptions"
            :tip="acceptanceTip"
            :required="!['backup', 'fail'].includes(acceptance.type)"
            @confirm="handleConformAcceptance"
        ></AcceptanceDialog>

        <!-- 交付弹框 -->
        <DeliveryDialog
            :visible.sync="deliveryDialog.visible"
            :title="deliveryDialog.title"
            @confirm="handleTaskResultConfirm"
        ></DeliveryDialog>

        <!-- 报名弹框 -->
        <SignupDialog
            :visible.sync="signupDialog.visible"
            :title="signupDialog.title"
            :task-id="isGetInfo ? task_id : undefined"
            @confirm="handleTaskApply"
        >
            <div class="dialog-tip" slot="tip" v-if="signupDialog.isModify">
                <i class="el-icon-warning"></i>
                仅支持修改
                <span>{{ this.taskData?.other_data?.max_modify_count }}次</span>
                报名信息。你当前还剩
                <span>{{ this.taskData?.other_data?.modify_count }}次</span> 修改机会
            </div>
        </SignupDialog>

        <ManuscriptDialog
            :visible.sync="manuscriptDialog.visible"
            :title="manuscriptDialog.title"
            :task-id="isGetInfo ? task_id : undefined"
            :budget="taskData?.task_budget || 0"
            @confirm="handleTaskApply"
        >
            <div class="dialog-tip" slot="tip">
                <i class="el-icon-warning"></i>
                交稿后稿件不可删除，请谨慎交稿！
            </div>
        </ManuscriptDialog>
    </div>
</template>

<script>
import ContractSignDialog from "./dialog/ContractSignDialog.vue";
import AcceptanceDialog from "./dialog/AcceptanceDialog.vue";
import DeliveryDialog from "./dialog/DeliveryDialog.vue";
import SignupDialog from "./dialog/SignupDialog.vue";
import ManuscriptDialog from "./dialog/ManuscriptDialog.vue";
import { request, actionDialogMap } from "../util";
import taskApi from "@/apis/task";
import { isEmpty } from "@/utils/common";

export default {
    data() {
        return {
            signVisible: false, // 合同签订标识符
            role: Number(localStorage.getItem("role")),

            // 操作弹框,
            acceptance: {
                visible: false,
                title: "",
                type: "", // fail-淘汰，backup-备选,  end-终止签约, pass-验收通过, return-返工
                plan: undefined, // 设置的plan
                formOptions: [], // 弹框form表单配置项
            },

            // 交付弹框
            deliveryDialog: {
                visible: false,
                title: "交付成果",
                // type: undefined, // 1-交付，2-重新交付
            },

            // 报名弹框
            signupDialog: {
                visible: false,
                title: "报名信息",
                isModify: false,
            },

            // 交稿弹框
            manuscriptDialog: {
                visible: false,
                title: "交稿信息",
            },

            task_id: Number(this.$route.query.id),

            request: request(),
        };
    },

    props: {
        taskData: {
            type: Object,
        },
    },

    components: {
        ContractSignDialog,
        AcceptanceDialog,
        DeliveryDialog,
        SignupDialog,
        ManuscriptDialog,
    },

    computed: {
        acceptanceTip() {
            // 验收通过
            if (this.acceptance.type === "pass") {
                return "请确认是否验收通过，验收通过后即交付金币哦";
            }

            return "";
        },

        // 是否需要获取稿件信息
        isGetInfo() {
            if (isEmpty(this.taskData?.task_todos)) return false;

            return this.taskData?.task_todos?.todo_key !== 0; // 取消报名
        },
    },

    methods: {
        // 事件分发
        eventDistribute(func, arg = []) {
            this[func]?.(...arg);
        },

        //#region 签订合同
        // 签订合同
        handleSignContract() {
            this.signVisible = true;
        },

        // 合同
        handleContractConfirm(val) {
            const params = {
                task_id: this.task_id,
                content: { ...val },
            };

            const contractApi = this.role === 4 ? taskApi.stuTaskContracts : taskApi.taskContracts;

            this.request.axiosPost(contractApi, params, (res) => {
                if (res.code === 200) {
                    this.$message.success(res.message);
                    this.signVisible = false;

                    // 重新请求数据
                    this.$emit("update", ["getResultList", "getDetail"]);
                } else {
                    this.$message.error(res.message);
                }
            });
        },
        //#endregion

        //#region 验收等操作，淘汰/备选/中标/终止合同/返工/通过
        // 回调操作
        handleStatusAction(type, plan = null) {
            const dialogInstance = actionDialogMap[type];

            if (dialogInstance) {
                this.acceptance.title = dialogInstance.title;
                this.acceptance.type = type;
                this.acceptance.formOptions = dialogInstance.formOptions;
                this.acceptance.plan = { id: plan?.id, task_id: plan?.task_id };
                this.acceptance.visible = true;
            }
        },

        // 弹框确认-按钮
        handleConformAcceptance(val) {
            const { text, score } = val;
            let params = {};
            let api = "";
            let callbacks = [];

            // 淘汰-备选
            if (["fail", "backup"].includes(this.acceptance.type)) {
                const statusMap = {
                    fail: 3,
                    backup: 2,
                };

                params = {
                    task_id: this.acceptance.plan?.task_id,
                    apply_id: this.acceptance.plan?.id,
                    status: statusMap[this.acceptance.type],
                    reply: text,
                };

                api = taskApi.changeApplyStatus;
                callbacks = ["getDetail", "getApplyList"];
            }

            // 终止合同
            if (this.acceptance.type === "end") {
                params = {
                    task_id: this.task_id,
                    content: { description: text },
                };

                api = taskApi.stuStopContract;
                callbacks = ["getDetail", "getResultList", "getApplyList"];
            }

            // 返工
            if (this.acceptance.type === "return") {
                params = {
                    task_id: this.task_id,
                    content: { description: text },
                };

                api = taskApi.taskRework;
                callbacks = ["getDetail", "getResultList"];
            }

            // 验收通过 | 评价
            if (["pass", "rating"].includes(this.acceptance.type)) {
                params = {
                    task_id: this.task_id,
                    rating: score,
                    evaluation_content: text,
                };

                api = taskApi.taskEvaluate;

                callbacks = ["getDetail", "getResultList"];
            }

            this.acceptanceAction(api, params, callbacks);
        },

        // 修改指定项的status - 备选-淘汰-中标-终止合同-返工-验收通过
        acceptanceAction(api, params, callbacks) {
            this.request.axiosPost(api, params, (res) => {
                if (res.code === 200) {
                    this.$message.success(res.message);

                    this.$emit("update", callbacks);
                    this.$refs.acceptDialogRef?.handleUpdateVisible?.(false)
                    // this.acceptance.visible = false;
                } else {
                    this.$message.error(res.message);
                }
            });
        },
        //#endregion

        //#region 交付成果
        // 提交任务成果-交付-重新交付
        handleSubmitResult() {
            const todoKey = this.taskData.task_todos.todo_key;

            this.deliveryDialog.title = todoKey === 3 ? "交付成果" : "重新交付";
            this.deliveryDialog.visible = true;
        },

        // 交付弹框确认 - 学生
        handleTaskResultConfirm(val) {
            const params = {
                task_id: this.task_id,
                content: { ...val },
            };

            this.request.axiosPost(taskApi.stuSubmitTask, params, (res) => {
                if (res.code === 200) {
                    this.$message.success(res.message);

                    this.deliveryDialog.visible = false;
                    this.$emit("update", ["getDetail", "getResultList"]);
                } else {
                    this.$message.error(res.message);
                }
            });
        },
        //#endregion

        //#region 报名
        // 报名弹框
        handleSignup(type) {
            const taskMode = this.taskData?.task_mode;

            // 招募
            if (taskMode === 1) {
                const signupTypeMap = {
                    sign: { title: "报名信息", modify: false },
                    reSign: { title: "重新报名", modify: false },
                    updateSign: { title: "修改报名", modify: true },
                };

                this.signupDialog.title = signupTypeMap[type]?.title ?? "报名信息";
                this.signupDialog.isModify = signupTypeMap[type]?.modify ?? false;
                this.signupDialog.visible = true;
            }

            // 竞单
            if (taskMode === 2) {
                const manuscriptTypeTitleMap = {
                    sign: "交稿信息",
                    reSign: "重新交稿",
                    updateSign: "修改稿件",
                };

                this.manuscriptDialog.title = manuscriptTypeTitleMap[type] ?? "稿件信息";
                this.manuscriptDialog.visible = true;
            }
        },

        // 报名任务请求
        handleTaskApply(val) {
            const params = {
                task_id: this.task_id,
                ...val,
            };

            this.request.axiosPost(taskApi.taskApply, params, (res) => {
                if (res.code === 200) {
                    this.$message.success(res);
                    this.signupDialog.visible = false;
                    this.manuscriptDialog.visible = false;

                    this.$emit("update", ["getDetail", "getApplyList"]);
                } else {
                    this.$message.error(res.message);
                }
            });
        },
        //#endregion
    },
};
</script>

<style lang="scss" scoped>
.dialog-box {
    .dialog-tip {
        background: #f0f5ff;
        border-radius: 4px;
        border: 1px solid #c2dbff;
        display: flex;
        align-items: center;
        gap: 4px;
        padding: 10px 16px;
        margin-bottom: 22px;

        * {
            font-weight: 500;
            font-size: 12px;
            color: #333333;
        }

        .el-icon-warning {
            color: #0066ff;
        }

        span {
            color: #ff0000;
        }
    }
}
</style>
